export const STATUS_ITEMS = ['Novo','Pendente','Concluido']
export const MODULES = [
      {  model: 'properties', description: 'Imóvel'}
    , {  model: 'condominiums', description: 'Condomínio'}
]

export const SUBJECTS = [
    'Solicitação de ativação',
    'Solicitação de alteração'
]